import React from 'react';
import FloatContainer from "../../Wrappers/FloatContainer";
import ActionButton from "../../Atoms/Templates/ActionButton";

const DropdownButton = ({children, icon, className}) => {
  return (
    <div className={`s-relative ${className}`}>
      <FloatContainer
        container={{
          className: 'float-container s-top-0 s-right-0'
        }}
      >
        <ActionButton icon={icon}/>
        <div className="ed-grid row-gap s-gap-1">
          {children}
        </div>
      </FloatContainer>
    </div>
  );
};



export default DropdownButton;
